<div>
<a routerLink="/zalozka/{{zalozka.id}}">
  <button type="button" class="btn btn-outline-primary" routerLinkActive="active-button">
  {{zalozka.nazov}}
  </button>
</a>
</div>
